import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkOutageService {

  constructor(private dataService: DataService) { }
  GetNetworkOutageList(){
    return this.dataService.getRecord('/api/NetworkOutage/GetNetworkOutageList')
  }
  SaveNetworkOutageDetails(payload){
    return this.dataService.post('/api/NetworkOutage/SaveNetworkOutageDetails',payload)
  }
  DeleteNetworkOutageById(id){
    return this.dataService.postWithQueryParms('/api/NetworkOutage/DeleteNetworkOutageById/'+id)
  }
  GetNetworkOutageById(id){
    return this.dataService.getRecordWithParams('/api/NetworkOutage/GetNetworkOutageById', id)
  }
  GetNetworkOutageBySearchQuery(payload){
    return this.dataService.post('/api/NetworkOutage/GetNetworkOutageBySearchQuery', payload)
  }
  ModifyNetworkOutageStatusById(id){
    return this.dataService.postWithQueryParms('/api/NetworkOutage/ModifyNetworkOutageStatusById/'+id)
  }

}
